"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _yaml = _interopRequireDefault(require("yaml"));

var _helpers = require("./helpers");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const addComments = (items, comments, prefix = '') => {
  items.forEach(item => {
    if (item.key !== undefined) {
      var _item$value;

      const itemKey = item.key.toString();
      const key = prefix ? "".concat(prefix, ".").concat(itemKey) : itemKey;

      if (comments[key]) {
        const value = comments[key].split('\\n').join('\n ');
        item.commentBefore = " ".concat(value);
      }

      if (Array.isArray((_item$value = item.value) === null || _item$value === void 0 ? void 0 : _item$value.items)) {
        addComments(item.value.items, comments, key);
      }
    }
  });
};

var _default = {
  fromFile(content) {
    if (content && content.trim().endsWith('---')) {
      content = content.trim().slice(0, -3);
    }

    return _yaml.default.parse(content, {
      version: '1.1'
    });
  },

  toFile(data, sortedKeys = [], comments = {}) {
    const contents = _yaml.default.createNode(data);

    addComments(contents.items, comments);
    contents.items.sort((0, _helpers.sortKeys)(sortedKeys, item => {
      var _item$key;

      return (_item$key = item.key) === null || _item$key === void 0 ? void 0 : _item$key.toString();
    }));
    const doc = new _yaml.default.Document();
    doc.contents = contents;
    return doc.toString();
  }

};
exports.default = _default;